// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../szc.cycz.cc/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-header[data-v-7904d984] {\n  margin: 0;\n}\n.search-table[data-v-7904d984] {\n  max-height: 600px;\n  overflow-y: scroll;\n}", ""]);
// Exports
module.exports = exports;
